import React from 'react';
import LogoSvg from '../../../assets/img/logo.svg';
import { properties } from '../../../../utils/properties'; 
import { WrapperLogo } from './styles';

const LogoHeader = () => {
  const volverACoopeuch = () => {
    window.location.href = properties.urlHomeCoopeuch;
  }

  return (
    <WrapperLogo>
      <img className="logo" src={LogoSvg} alt="logo" onClick={volverACoopeuch} aria-hidden="true" />
    </WrapperLogo>
  );
}

export default LogoHeader;